import { render, staticRenderFns } from "./ServicesTableItemSkeletonMobile.vue?vue&type=template&id=3010a6b3&scoped=true"
import script from "./ServicesTableItemSkeletonMobile.vue?vue&type=script&lang=js"
export * from "./ServicesTableItemSkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./ServicesTableItemSkeletonMobile.vue?vue&type=style&index=0&id=3010a6b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010a6b3",
  null
  
)

export default component.exports